import { jsx as _jsx } from "react/jsx-runtime";
import { FullWidthCTA } from "@cinch-labs/design-system";
import { EventCategories, EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { useRouter } from "next/router";
import styles from "./prefooter.module.css";
export const Prefooter = (blok)=>{
    const { title , subtitle , iconName , buttonLabel  } = blok;
    const router = useRouter();
    const { trackEvent  } = useAnalytics();
    const handleClick = ()=>{
        trackEvent({
            eventName: `Our commitment - ${buttonLabel}`,
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: EventCategories.button,
                    label: buttonLabel
                }
            }
        });
        router.push("/used-cars");
    };
    return /*#__PURE__*/ _jsx(FullWidthCTA, {
        iconName: iconName,
        iconGradient: "galaxy",
        iconSize: 41,
        title: title,
        subtitle: subtitle,
        buttonLabel: buttonLabel,
        onButtonClick: handleClick,
        className: styles.container
    });
};
